export default __webpack_public_path__ + "static/828-a829420588344ef3e6e3f92f81032031.gif";